<template>
  <div v-if="!isMobile">
    <Popover
      v-model="desktopOpen"
      class="h-full w-full"
      hide-on-mobile
      no-padding
      custom-action-handler
      :content-style="{ padding: 0 }"
    >
      <template #action>
        <button
          :class="buttonClasses"
          @click="toggleOpen"
          @keydown.space="toggleOpen"
        >
          {{ label }}
          <TagIcon
            :icon="ChevronDownIcon"
            color="mono-black"
            class="ml-1 h-4 w-4"
          />
        </button>
      </template>

      <div>
        <Price
          :form="form"
          price-method-display-style="buttonGroup"
          class="p-6"
          style="width: 484px"
          @change="change"
          @priceChange="priceChange"
        />

        <ClearAndSubmit
          :is-loading="isLoading"
          :submit-label="submitLabel"
          @clear="clear"
          @submit="submit"
        />
      </div>
    </Popover>
  </div>
</template>

<script>
import ChevronDownIcon from '@tagvenue/icons/24/bold/arrows/chevron-down.svg';
import { markRaw } from 'vue';
import { mapGetters, mapState } from 'vuex';

import TagIcon from '@/components/TagIcon.vue';
import Popover from '@/components/Ui/Popover.vue';
import ClearAndSubmit from '@/modules/public/search/components/SearchFilters/components/ClearAndSubmit.vue';

import SearchOptionShared from '../SearchOptionShared.js';
import Price from './Price.vue';

export default {
  name: 'PriceOption',
  mixins: [SearchOptionShared],
  components: { ClearAndSubmit, Price, Popover, TagIcon },
  data() {
    return {
      ChevronDownIcon: markRaw(ChevronDownIcon),
    };
  },
  computed: {
    ...mapState([
      'l10n',
    ]),
    ...mapGetters([
      'priceRangeWithDefaults',
    ]),
    form() {
      const { priceRange, priceMethod } = this.$store.state.filters;
      return {
        priceMethod: priceMethod.value,
        priceRange: [priceRange.value.from, priceRange.value.to],
      };
    },
    label() {
      if (this.$store.getters.isPriceFilterDefault) {
        return 'Price';
      }
      const isMaxValue = this.$store.getters.isMaxPriceFilterDefault;
      const suffix = isMaxValue ? '+' : '';
      const isOnlyMaxPriceProvided = this.$store.getters.isMinPriceFilterDefault && !this.$store.getters.isMaxPriceFilterDefault;
      if (isOnlyMaxPriceProvided) {
        return `Up to ${this.l10n.currencySign}${this.priceRangeWithDefaults[1]}${suffix}`;
      }
      return `${this.l10n.currencySign}${this.priceRangeWithDefaults[0]} - ${this.l10n.currencySign}${this.priceRangeWithDefaults[1]}${suffix}`;
    },
    isSelected() {
      return !this.$store.getters.isPriceFilterDefault || this.$store.state.filters.priceMethod.value;
    },
  },
  watch: {
    '$store.state.triggerSection': {
      handler(value) {
        if (value === 'price') {
          this.desktopOpen = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    change(key, value) {
      if (key === 'priceMethod') {
        const val = value === this.form.priceMethod ? null : value;
        this.$store.commit('priceMethodChange', val);
        this.$store.commit('resetPriceRange');
        this.apply({ name: 'priceMethod', value: val });
      }
      if (key === 'priceRange') {
        this.$store.commit('priceChange', value);
      }
    },
    clear() {
      this.$store.commit('priceMethodChange', null);
      this.$store.commit('resetPriceRange');
      this.apply({ name: 'RemoveFilter', value: 'price' });
    },
    priceChange() {
      this.apply({ name: 'Price', value: this.form.priceRange });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.closeOnScrollThrottled);
  },
  unmounted() {
    window.removeEventListener('scroll', this.closeOnScrollThrottled);
  },
};
</script>

<style lang="scss" scoped>
@use '../optionButton';

.option__button {
  @include optionButton.optionButton;
}

</style>
